import { createLogger, getLocalStorageObject, setLocalStorageString, } from "../../utils";
const LS_RESULT_KEY = "ats_3p_cookies_result";
const logger = createLogger("cookie-check");
function isPersistedCookieCheckerState(value) {
    function isRecord(obj) {
        return typeof obj === "object" && obj !== null;
    }
    if (isRecord(value) &&
        Object.prototype.hasOwnProperty.call(value, "timestamp") &&
        typeof value.timestamp === "number" &&
        "result" in value &&
        typeof value.result === "boolean") {
        return true;
    }
    return false;
}
const state = {
    checkUrl: `https://assets.tunnus.almamedia.fi/cookies/cookieCheckStart.html`,
    checkIsRunning: false,
    thirdPartyCookiesEnabled: undefined,
    checkStarted: undefined,
};
const cookieCheckIframeName = "ats-cookie-check-iframe";
function removeIframe() {
    const frame = document.getElementsByName(cookieCheckIframeName)[0];
    if (frame && frame.parentNode) {
        logger.logInfo("removing iframe");
        frame.parentNode.removeChild(frame);
    }
}
async function thirdPartyCookiesEnabled(timeout = 500) {
    if (typeof state.thirdPartyCookiesEnabled === "boolean") {
        logger.logInfo(`Found result: ${state.thirdPartyCookiesEnabled}`);
        return state.thirdPartyCookiesEnabled;
    }
    const persistedState = getLocalStorageObject(LS_RESULT_KEY);
    if (isPersistedCookieCheckerState(persistedState) &&
        persistedState.timestamp - Date.now() < 60 * 60 * 24 * 1000) {
        logger.logInfo(`Found result from LS`);
        state.thirdPartyCookiesEnabled = persistedState.result;
        return state.thirdPartyCookiesEnabled;
    }
    try {
        window.localStorage.removeItem(LS_RESULT_KEY);
    }
    catch (e) {
        logger.logError(`Error while clearing LS: ${e}`);
    }
    if (typeof window?.ALMA?.tunnus?.cookiesEnabled === "function") {
        logger.logInfo(`Using Alma Tunnus checker`);
        const result = window.ALMA.tunnus.cookiesEnabled();
        if (typeof result === "boolean") {
            state.thirdPartyCookiesEnabled = result;
            return state.thirdPartyCookiesEnabled;
        }
    }
    let cookieCheckTimeout;
    const iframeEventListener = (resolve) => (evt) => {
        if (evt.data === "at-cookies-false" || evt.data === "at-cookies-true") {
            if (state.checkStarted) {
                logger.logInfo(`Check result after ${window.performance.now() - state.checkStarted} ms`);
            }
            const cookies = evt.data === "at-cookies-true";
            logger.logInfo(`3rdp cookies: at-cookies-${cookies}`);
            state.checkIsRunning = false;
            state.thirdPartyCookiesEnabled = cookies;
            // Try to persist state
            const persistedResult = {
                timestamp: Date.now(),
                result: state.thirdPartyCookiesEnabled,
            };
            try {
                setLocalStorageString(LS_RESULT_KEY, JSON.stringify(persistedResult));
            }
            catch (e) {
                logger.logError(`Unable to persist check result`);
            }
            if (cookieCheckTimeout) {
                clearTimeout(cookieCheckTimeout);
            }
            resolve(cookies);
            removeIframe();
        }
    };
    const runCookieCheck = () => {
        state.checkIsRunning = true;
        const iframe = document.createElement("iframe");
        iframe.setAttribute("name", cookieCheckIframeName);
        iframe.setAttribute("style", "display: none");
        iframe.setAttribute("src", `${state.checkUrl}?t=${new Date().getTime()}`);
        document.body.appendChild(iframe);
    };
    return new Promise((resolve, reject) => {
        logger.logInfo(`Starting 3P cookie check with timeout of ${timeout} ms`);
        state.checkStarted = window.performance.now();
        cookieCheckTimeout = setTimeout(() => {
            const errMessage = `Cookie check timeout (${timeout} ms)`;
            logger.logError(errMessage);
            reject(new Error(errMessage));
        }, timeout);
        window.addEventListener("message", iframeEventListener(resolve), false);
        if (!state.checkIsRunning)
            runCookieCheck();
    });
}
async function browserIsSafari() {
    return /.*Version.*Safari.*/.test(navigator.userAgent);
}
// eslint-disable-next-line import/prefer-default-export
export { thirdPartyCookiesEnabled, browserIsSafari };
//# sourceMappingURL=cookie-check.js.map